import {
    Banner,
    BannerDescription,
    BannerLinks,
    BannerText,
    BannerTextContainer,
    BannerTitle,
    Button,
    FlexBox,
    FluidImage,
    H2,
    Link,
    P,
    tokensRaw,
} from '@vp/swan';
import styled from 'styled-components';
import { FormattedHTMLMessage, __ } from '@99designs/i18n';
import { sendNavigationEvent, usePage } from '@99designs/tracking';
import designConsultationImage from '../../images/design-consultation.png';

const DESIGN_CONSULTATION_SCHEDULING_URL =
    'https://app.acuityscheduling.com/schedule/8eaa6666/appointment/73367686/calendar/any?appointmentTypeIds%5B%5D=73367686';

// Mobile users should see the banner on the bottom, not the top.

const StyledBanner = styled(Banner)`
    @media (max-width: ${tokensRaw.SwanBaseBreakpointXsEnd}) {
        flex-direction: column-reverse;
    }
`;

export default function DesignConsultationBanner() {
    const { pageData } = usePage();

    // This normalisation will allow images to work in NextJS and non-NextJS environments.

    const normalizedDesignConsultationImage =
        typeof designConsultationImage === 'string'
            ? { src: designConsultationImage }
            : designConsultationImage || {};

    return (
        <StyledBanner
            bgc="transparent"
            variant="card"
            data-testid="design-consultation-banner"
            textBoxHorizontalAlign="right"
        >
            <BannerTextContainer>
                <BannerText marginLeft="0">
                    <BannerTitle as={H2}>
                        <FormattedHTMLMessage
                            message={__('A free design consultation?<br/>Yes, please!')}
                        />
                    </BannerTitle>
                    <BannerDescription>
                        <P>
                            {__(
                                'Book a free consultation with one of our expert designers so you can fill in a design brief like a pro. They’ll help you to capture all the important details so you’re left with a brief that’s clear, concise and ready to be worked on.'
                            )}
                        </P>
                    </BannerDescription>
                    <BannerLinks>
                        <Button
                            skin="secondary"
                            render={(props) => (
                                <Link
                                    to={DESIGN_CONSULTATION_SCHEDULING_URL}
                                    className={props.className}
                                    onClick={() => {
                                        const ctaValue = 'Acuity Scheduler-freeDesignConsultation';
                                        sendNavigationEvent({
                                            ...pageData,
                                            category: pageData.pageSection,
                                            label: `Content:Design Consultation Banner`,
                                            eventDetail: `/design;${DESIGN_CONSULTATION_SCHEDULING_URL};Design Consultation Banner;${ctaValue}`,
                                            navigationDetail: ctaValue,
                                        });
                                    }}
                                >
                                    {props.children}
                                </Link>
                            )}
                        >
                            {__('Book your consultation')}
                        </Button>
                    </BannerLinks>
                </BannerText>
            </BannerTextContainer>
            <FlexBox
                flexDirection="column"
                justifyContent="center"
                alignItems="flex-start"
                style={{ flexBasis: '50%' }}
            >
                <FluidImage
                    src={normalizedDesignConsultationImage.src}
                    alt=""
                    role="presentation"
                />
            </FlexBox>
        </StyledBanner>
    );
}
